import { render, staticRenderFns } from "./AlertsConfigurator.vue?vue&type=template&id=5a377b16&scoped=true&"
import script from "./AlertsConfigurator.vue?vue&type=script&lang=js&"
export * from "./AlertsConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./AlertsConfigurator.vue?vue&type=style&index=0&id=5a377b16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a377b16",
  null
  
)

/* custom blocks */
import block0 from "./AlertsConfigurator.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports